import { Combinator, SearchQuery } from 'modules/domains';

import { ElementType, useElementIndex } from '../../contexts';
import { useCriteriaArray } from './useCriteriaArray';

const DEFAULT_CRITERIA = { combinator: Combinator.AND, searchQueries: [] };

export const useCriteria = (): SearchQuery => {
  const criteriaIndex = useElementIndex(ElementType.Criteria);
  const criteriaArray = useCriteriaArray();
  return criteriaArray[criteriaIndex] ? criteriaArray[criteriaIndex] : DEFAULT_CRITERIA;
};
